export default "/images/vendor/leaflet.fullscreen/icon-fullscreen.svg?a8f4a7de091d4a05f2de444ff0c6a9e9";